import React, { useState, memo } from 'react';

import JsonEditor from '../../../../JsonEditor';
import SimpleModal from '../../../../SimpleModal';

const CreateSourceModal = memo((properties) => {
  const { schemas, onSubmit, onCloseModal, transformErrors, customFormats, customValidate } =
    properties;

  const [formData, setFormData] = useState({ type: 'default' });

  const onChange = ({ formData: updatedFormData }) => {
    setFormData(updatedFormData);
  };

  return (
    <SimpleModal
      onClose={onCloseModal}
      title="Add source"
      overlayCanClose={false}
    >
      <div className="file-upload-modal">
        <div className="file-upload-content">
          <JsonEditor
            title="Source"
            formData={formData}
            schema={schemas[formData.type]}
            onFormChange={onChange}
            onFormSubmit={({ formData: form }) => onSubmit(form)}
            saveButtonText={'Create source'}
            initialEditMode={true}
            editorOnly={true}
            showEditButton={false}
            cancelCallback={onCloseModal}
            customTransformErrors={(errors) => transformErrors(errors)}
            customFormats={customFormats}
            customValidate={customValidate}
          />
        </div>
      </div>
    </SimpleModal>
  );
});

export default CreateSourceModal;
